<template>
  <tr>
    <td>
      <DocumentFavorite
        :is-favorite="document.attributes.is_favorite"
        :document="document"
      />
    </td>
    <!--<td><img style="height: 20px" src="\document-icon.png"></td>-->
    <td>
      <a
        :href="downloadUrl"
        target="_blank"
        rel="noopener noreferrer"
        v-html="title"
      />
    </td>
    <td v-html="modified" />
    <td>
      <a
        :href="folderUrl"
        v-html="folderName"
      />
    </td>
    <td>
      <a
        class="icon"
        :href="downloadUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
        >
          <g
            fill="#231F20"
            fill-rule="evenodd"
            stroke="#231F20"
            stroke-width=".5"
          >
            <path d="M7.5 7.5A.5.5 0 0 0 7 7H1.5a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h22a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5H18a.5.5 0 0 0 0 1h5v14H2V8h5a.5.5 0 0 0 .5-.5z" /><path d="M12.5 1a.5.5 0 0 0-.5.5v13.793l-3.146-3.146a.5.5 0 0 0-.708.707l3.999 3.999a.496.496 0 0 0 .708 0l3.999-3.999a.5.5 0 0 0-.707-.707L13 15.293V1.5a.5.5 0 0 0-.5-.5z" />
          </g>
        </svg>
      </a>
    </td>
    <td v-can="'edit-documents'">
      <DocumentActions :document="document" />
    </td>
  </tr>
</template>

<script type="text/babel">
import DocumentFavorite from './DocumentFavorite'
import DocumentActions from './DocumentActions'

export default {
  name: 'FavoriteDocumentRow',
  components: {
    DocumentActions,
    DocumentFavorite,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  computed: {
    downloadUrl() {
      return this.$urlGenerator.active(`documents/${this.document.uuid}/download`)
    },
    title() {
      return this.document.attributes.title
    },
    modified() {
      return this.$date.toMomentDateFormat(this.document.attributes.created_at)
    },
    folderName() {
      return this.document.folder.attributes.title
    },
    folderUrl() {
      return this.$urlGenerator.active(`documents/folders/${this.document.folder.uuid}`)
    },
  },
}
</script>
